// extracted by mini-css-extract-plugin
export default {"countdown-banner":"countdown-banner-e38e","text-container":"text-container-fbf8"};